import React from "react";
import { render } from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { configure } from "mobx";
import mixpanel from "mixpanel-browser";
import userStore from "./Stores/User";
import "react-notifications/lib/notifications.css";

configure({ enforceActions: "always" });

mixpanel.init(process.env.REACT_APP_MIXPANEL_API_KEY, {
  ignore_dnt: true,
  record_sessions_percent: 10,
  loaded: () => {
    userStore.updateTrackingId(mixpanel.get_distinct_id());
  },
});

reportWebVitals();

if (navigator.serviceWorker) {
  window.addEventListener("beforeinstallprompt", (e) => {
    if (e.userChoice) {
      e.userChoice.then((result) => {
        if (result.outcome === "accepted") {
          mixpanel.track("PWA installed");
        }
      });
    }
  });

  navigator.serviceWorker.register("/sw.js");
}

render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
